import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { HttpParams } from '@angular/common/http';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Manufacturer } from '@models/manufacturer';
import { ManufacturersService } from '@services/entity/manufacturer.services';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'app-create-chargingstationprofile',
  templateUrl: './create-chargingstationprofile.component.html',
  styleUrls: ['./create-chargingstationprofile.component.scss']
})
export class CreateChargingStationProfileComponent extends AbstractCreateEntityComponent implements OnInit {

  public className = 'CreateChargingStationProfileComponent';

  public customerId: number;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private manufacturersService: ManufacturersService,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector) {
    super(manufacturersService, injector);
  }

  createForm() {
    this.formService.validators = {
      name: [Validators.required],
    }

    this.formService.form = new FormGroup({
      name: new FormControl('', this.formService.validators['name']),
    });
  }
  

  onSubmit(formValue) {
    var manufacturer = new Manufacturer(formValue);
      this.manufacturersService.createEntity(manufacturer).subscribe(result => {
        this.newEntityEvent.emit(manufacturer);
        this.toastService.success('Profil wurde angelegt.');
      }, error => {
        this.toastService.error('Profil konnte nicht angelegt werden.');
      })
  }
}
